import cookies from 'lib/Cookies';

const E2E_COOKIE_NAME = 'e2eTest';

let _isE2ETest: boolean | undefined;
export const isE2ETest = () => {
  if (_isE2ETest === undefined) {
    _isE2ETest = !!cookies.get(E2E_COOKIE_NAME);
  }

  return _isE2ETest;
};
